// vulnerable.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const useVulnerableStore = defineStore('vulnerable', {
    state: () => ({
        allVulnerable: [],
        vulnerableList: [],
    }),
    actions: {
        async getAllVulnerable(filter) {
            try {
                const response = await axios.get('/vulnerable-groups/list', { params: filter })
                if (response.status === 200) {
                    this.allVulnerable = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getVulnerable(filter) {
            try {
                const response = await axios.get('/vulnerable-groups', { params: filter })
                if (response.status === 200) {
                    this.vulnerableList = response.data.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getVulnerableById(id) {
            try {
                const response = await axios.get(`/vulnerable-group/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async createVulnerable(body) {
            try {
                const response = await axios.post('/vulnerable-group', body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async updateVulnerable(body) {
            try {
                const response = await axios.post(`/vulnerable-group/${body.id}`, body)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async vulnerableDeleteCheck(id, filter) {
            try {
                const response = await axios.get(`/vulnerable-group/${id}/deletion-check`, { params: filter, noLoader: true })
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteVulnerable(id) {
            try {
                const response = await axios.delete(`/vulnerable-group/${id}`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})
